import { Dispatch } from 'redux';
import Event from './Event';

export default interface DispatchProps {
    dispatch: (event: Event) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    dispatch: (event: Event): void => {
        dispatch(event);
    }
});



// WEBPACK FOOTER //
// ./src/application/core/DispatchProps.ts